<template>
    <div class="qa">
        <div class="qa-list">
            <div class="qa-item">
                <div class="q">
                    <div class="q-icn">Q</div>
                    <div class="q-text">什么是情绪识别？</div>
                </div>
                <div class="a">
                    <div class="a-icn">
                        <div class="icn-text">A</div>
                    </div>
                    <div class="a-text">情绪识别是指通过智能硬件收集生理数据并以此识别您目前情绪的算法技术。</div>
                </div>
            </div>
            <div class="qa-item">
                <div class="q">
                    <div class="q-icn">Q</div>
                    <div class="q-text">情绪识别是如何实现的？科学吗？</div>
                </div>
                <div class="a">
                     <div class="a-icn">
                        <div class="icn-text">A</div>
                    </div>
                    <div class="a-text">情绪识别基于中科院研发团队多年研究的rri情绪识别算法，通过收集心率、心率间隙等基础生理数据进行深入分析，并输出情绪、压力和疲劳状态等指标的量化数值，识别结果经过研究验证准确可靠</div>
                </div>
            </div>
            <div class="qa-item">
                <div class="q">
                    <div class="q-icn">Q</div>
                    <div class="q-text">情绪识别对我有什么用？</div>
                </div>
                <div class="a">
                     <div class="a-icn">
                        <div class="icn-text">A</div>
                    </div>
                    <div class="a-text">情绪识别能够感知我们自身的压力，通过测量情绪、压力、疲劳度等指标客观测量人体数据，根据测量结果能更加客观地调节自我，并基于我们推荐的服务更有目的性的调节情绪和身心健康。</div>
                </div>
            </div>
        </div>        
        <div class="bot">~已经到底了~</div>
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {},
};
</script>
<style lang='less' scoped>
.qa{
    padding:16px 16px 0px 16px ;
    padding-bottom: 60px;
}
.qa-item{
    border-radius: 10px;
    margin-bottom: 12px;
}
.q{
    border-radius: 10px 10px 0px 0px;
    background-color: #01D6D6;
    padding: 15px;
    display: flex;
    justify-content: flex-start;
}
.q-icn{
    height: 20px;
    line-height: 20px;
    width: 20px;
    text-align: center;
    background-color: #fff;
    font-size: 12px;
    color: #01D6D6;
    font-weight: bold;
    border-radius: 50%;
    margin-right: 10px;
}
.q-text{
    line-height: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
}
.a{
    border-radius: 0px 0px 10px 10px;
    background-color: #fff;
    padding: 15px;
    display: flex;
    justify-content: flex-start;
}
.a-icn{
    height: 20px;
    width: 20px;
    margin-right: 10px;
}
.icn-text{
    height: 20px;
    line-height: 20px;
    width: 20px;
    text-align: center;
    background-color: #01D6D6;
    font-size: 12px;
    color: #fff;
    font-weight: bold;
    border-radius: 50%;
}
.a-text{
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #666666;
}
.bot{
    height: 20px;
    line-height: 20px;
    text-align:center;
    font-size: 12px;
    font-weight: 400;
    color: #999999;
    margin-bottom: 12px;
}
</style>